var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-indicator",style:({ color: _vm.textColor })},[_c('span',{class:['dot', _vm.pointSize, _vm.statusColor]}),_c('span',{class:_vm.textSize},[_vm._v(_vm._s(_vm.statusText))])])}
var staticRenderFns = []

export { render, staticRenderFns }